/**
 * @typedef State
 * @property {boolean} loading
 * @property {boolean} loading
 */

/**
 * @typedef Action
 * @property {'FETCH'|'FETCH_SUCCEEDED'|'FETCH_FAILED'} type
 * @property {*=} data
 */

/**
 * @param {ReturnType<typeof useAxiosReducer.createInitialState>} state
 * @param {Action} action
 */
export default function useAxiosReducer(state, action) {
  if (action.type === 'FETCH') {
    return {
      ...state,
      loading: true,
    }
  }

  if (action.type === 'FETCH_SUCCEEDED') {
    return {
      loading: false,
      data: action.data,
      error: null,
    }
  }

  if (action.type === 'FETCH_FAILED') {
    return {
      loading: false,
      data: null,
      error: action.data,
    }
  }

  return state
}

useAxiosReducer.createInitialState = function (skip, data = null) {
  return {
    loading: !skip,
    data,
    error: null,
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useAxios/reducer.js